import { NivelToast } from "../../../isp._comun/iu/componentes/widgets/notificacionesToast/ConstantesToast";
import { TipoZona, Udm } from "../../../isp.žapi.zonas/constantesApiZonas";

/* const TipoZona = {
    PlanInternet: "planInt",
    ServiciosGen: "servGen",
    Articulo: "art",
};

const Udm = {
    Mensual: "mensual",
    Unidad: "unid",
};

const Moneda = {
    Soles: "sol",
    Dolares: "usd",
}; */
const DataEstaticaDeRespuesta = {
    CreacionZona: {
        titulo: "Creación Exitosa",
        mensaje: "Creación de una Zona con nombre: ",
        nivel: NivelToast.EXITO,
    },
    ZonaDuplicada: {
        titulo: "Zona Duplicada",
        mensaje: "Otro usuario agregó antes la zona ",
        nivel: NivelToast.INFO,
    },
};

const EstadosZonaLabel = {
    HAB: "Habilitado",
    DHAB: "En Baja",
};

const TipoZonaLabel = {};
// TipoZonaLabel[TipoZona.PlanInternet] = "Plan.Int.";
TipoZonaLabel[TipoZona.ServiciosGen] = "Serv. Gen.";
TipoZonaLabel[TipoZona.Articulo] = "Articulo";

const UnidadZonaLabel = {};
// UnidadZonaLabel[Udm.Mensual] = "Mensual";
UnidadZonaLabel[Udm.Unidad] = "Unid.";

export { DataEstaticaDeRespuesta, TipoZonaLabel, UnidadZonaLabel, EstadosZonaLabel };
